/**
 * This list is used to map the product code to the untranslated product name.
 * It is used in `@landr/pricing` and MFEs, so be careful when updating a value.
 */
var UntranslatedPlanNames = /*#__PURE__*/function (UntranslatedPlanNames) {
  UntranslatedPlanNames["Essentials"] = "Essentials";
  UntranslatedPlanNames["Standard"] = "Standard";
  UntranslatedPlanNames["Pro"] = "Pro";
  UntranslatedPlanNames["StudioEssentials"] = "Studio Essentials";
  UntranslatedPlanNames["StudioStandard"] = "Studio Standard";
  UntranslatedPlanNames["StudioPro"] = "Studio Pro";
  UntranslatedPlanNames["LandrStudioEssentials"] = "LANDR Studio Essentials";
  UntranslatedPlanNames["LandrStudioStandard"] = "LANDR Studio Standard";
  UntranslatedPlanNames["LandrStudioPro"] = "LANDR Studio Pro";
  return UntranslatedPlanNames;
}({});

export { UntranslatedPlanNames };
